module.exports = __webpack_public_path__ + "static/media/instructions.fd08468e.jpg";